const store = {
    namespaced: true,
    state: {
        search_count: 0,
        not_useds: [],
        useds: [],
    },
    getters: {
    },
    mutations: {
    }
}

export default store
